import clsx from 'clsx';
import {SanityTable} from '../../../types';

type Props = {
  table: SanityTable;
  label?: string;
};
export default function Table({table, label}: Props) {
  return (
    <>
      <div className="mt-6 text-xs">
        {table.rows.map((row, index) => (
          <div
            key={row._key}
            className={clsx(
              'grid items-center justify-center',
              'grid-cols-11 border-b border-neutral-300',
              index === 0 ? 'text-neutral-900' : 'text-neutral-500',
            )}
          >
            {row.cells.map((cell, index) => (
              <span
                key={index}
                className={clsx(
                  'py-3 leading-[.8]',
                  index === 0
                    ? 'col-span-2 text-sm text-neutral-900'
                    : 'text-right',
                )}
              >
                {cell}
              </span>
            ))}
          </div>
        ))}
      </div>
      <p className="mt-4 text-center text-xs text-neutral-500">{label}</p>
    </>
  );
}
